class FooterAccordion {
  constructor({ triggerSelector, itemSelector, panelSelector, singleOpen = false }) {
    this.triggers = document.querySelectorAll(triggerSelector);
    this.itemSelector = itemSelector;
    this.panelSelector = panelSelector;
    this.singleOpen = singleOpen;

    this.init();
    this.initObservers();
  }


    init() {
    this.triggers.forEach(trigger => {
        trigger.addEventListener("click", () => this.toggle(trigger));
    });

    this.openFirst();
    }

    openFirst() {
    if (!this.singleOpen) return;

    const firstItem = document.querySelector(this.itemSelector);
    if (!firstItem) return;

    const panel = firstItem.querySelector(`:scope > ${this.panelSelector}`);

    firstItem.classList.add("is-open");
    firstItem.dataset.open = 'true';

    requestAnimationFrame(() => {
        panel.style.maxHeight = panel.scrollHeight + "px";
    });
    }

  toggle(trigger) {
    const item = trigger.closest(this.itemSelector);
    const panel = item.querySelector(`:scope > ${this.panelSelector}`);
    const isOpen = item.classList.contains("is-open");

    if (this.singleOpen && !isOpen) {
      this.closeAll(item);
    }

    if (isOpen) {
      this.close(item, panel);

    } else {
      this.open(item, panel);
    }

    this.updateParentDatasets(panel);
  }

  open(item, panel) {
    item.classList.add("is-open");
    item.dataset.open = 'true';
    panel.style.maxHeight = panel.scrollHeight + "px";

    // Auto-open first child accordion when a parent accordion opens
    this.openFirstChild(item, panel);
  }

  openFirstChild(item, panel) {
    const firstChildItem = panel.querySelector(".nav-sub-acc-item");
    if (!firstChildItem || firstChildItem.classList.contains("is-open")) return;

    const childPanel = firstChildItem.querySelector(":scope > .nav-sub-acc-panel");
    if (!childPanel) return;

    firstChildItem.classList.add("is-open");
    firstChildItem.dataset.open = 'true';

    requestAnimationFrame(() => {
      childPanel.style.maxHeight = childPanel.scrollHeight + "px";
      // Recalculate parent panel height to account for the opened child
      panel.style.maxHeight = panel.scrollHeight + "px";
    });
  }

  close(item, panel) {
    item.classList.remove("is-open");
    item.dataset.open = 'false';
    panel.style.maxHeight = "0px";
  }

  closeAll(currentItem) {
    document.querySelectorAll(this.itemSelector).forEach(item => {
      if (item === currentItem) return;

      const panel = item.querySelector(`:scope > ${this.panelSelector}`);
      item.classList.remove("is-open");
      item.dataset.open = 'false';

      if (panel) {
        panel.style.maxHeight = "0px";
      }
    });
  }

  initObservers() {
    const panels = document.querySelectorAll(this.panelSelector);

    this.observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const panel = entry.target;
        const item = panel.closest(this.itemSelector);

        if (!item || !item.classList.contains("is-open")) return;

        panel.style.maxHeight = panel.scrollHeight + "px";
        this.updateParents(panel);
      });
    });

    panels.forEach(panel => {
      this.observer.observe(panel);
    });
  }

  updateParents(element) {
    let parent = element.parentElement;

    while (parent) {
      if (
        parent.classList &&
        (parent.classList.contains("nav-acc-item") || parent.classList.contains("nav-sub-acc-item"))
      ) {
        if (parent.classList.contains("is-open")) {
          const panel = parent.querySelector(
            ":scope > .nav-acc-panel, :scope > .nav-sub-acc-panel"
          );

          if (panel) {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        }
      }

      parent = parent.parentElement;
    }
  }

  updateParentDatasets(element) {
    let parent = element.parentElement;

    while (parent) {
      if (
        parent.classList &&
        (parent.classList.contains("nav-acc-item") || parent.classList.contains("nav-sub-acc-item") || parent.classList.contains("menu-drawer__navigation"))
      ) {
        const isOpen = parent.classList.contains("is-open");
        const newOpen = isOpen ? 'true' : 'false';


        const parentDrawerContainer = parent.closest(".menu-drawer__navigation");
        if (parentDrawerContainer) {
          const containerOpen = parent.dataset.open === 'true' ? 'true' : 'false';
          if (parentDrawerContainer.dataset.open !== containerOpen) {
            parentDrawerContainer.dataset.open = containerOpen;
          }
        }
      }

      parent = parent.parentElement;
    }
  }
}


// INIT
document.addEventListener("DOMContentLoaded", () => {

  new FooterAccordion({
    triggerSelector: ".footer-acc-trigger",
    itemSelector: ".footer-acc-item",
    panelSelector: ".footer-acc-panel",
    singleOpen: false,
    openFirst: true
  });

});